import { render, staticRenderFns } from "./PCol.vue?vue&type=template&id=21ebaeba&scoped=true&"
import script from "./PCol.vue?vue&type=script&lang=ts&"
export * from "./PCol.vue?vue&type=script&lang=ts&"
import style0 from "./PCol.vue?vue&type=style&index=0&id=21ebaeba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ebaeba",
  null
  
)

export default component.exports